// PrivateRoute.js
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './authProvider';

export function PrivateRoute() {
  const auth = useAuth();
  
  if (auth.status === 'loading') return <div className='min-h-screen flex items-center justify-center'>
    Wird geladen...
  </div>;
  if (auth.status !== 'authenticated') return <Navigate to="/auth" replace />;
  return <Outlet />;
}
